import React, { useEffect, useState } from "react";
import { WS_NOTIF_URL } from "../config";
import CallInteractionModal from "./CallInteractionModal";
import { useAuth } from "../Contexts/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faTimes, faCalendarCheck } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export default function AppNotificationHandler() {
  const { user } = useAuth();
  const [activeCall, setActiveCall] = useState(null);
  const [activeReminder, setActiveReminder] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const savedCall = localStorage.getItem("crm:pending_call");
    if (savedCall) {
      try {
        setActiveCall(JSON.parse(savedCall));
      } catch (e) {
        localStorage.removeItem("crm:pending_call");
      }
    }
  }, []);

  useEffect(() => {
    if (activeCall) {
      localStorage.setItem("crm:pending_call", JSON.stringify(activeCall));
    } else {
      localStorage.removeItem("crm:pending_call");
    }
  }, [activeCall]);

  useEffect(() => {
    if (!user) return;

    const token = localStorage.getItem("accessToken");
    const socketUrl = `${WS_NOTIF_URL}?token=${token}`;
    
    let socket = new WebSocket(socketUrl);

    const handleMessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log("WebSocket message received:", data);
        
        if (data.type === 'notification') {
          const notif = data.notification;
          
          if (notif.notification_type === 'call_received' || (notif.type === 'call_received')) {
            const callInfo = notif.data || notif;
            setActiveCall(callInfo);
          } 
          else if (notif.notification_type === 'event_reminder') {
            setActiveReminder(notif);
            setTimeout(() => {
              setActiveReminder(prev => (prev?.id === notif.id ? null : prev));
            }, 10000);
          }
        }
      } catch (err) {
        console.error("Failed to parse socket message", err);
      }
    };

    socket.onmessage = handleMessage;
    socket.onopen = () => console.log("Notification WebSocket connected");
    socket.onerror = (err) => console.error("Notification WebSocket error", err);
    socket.onclose = () => {
        console.log("Notification WebSocket closed. Retrying...");
        setTimeout(() => {
            if(user) {
                socket = new WebSocket(socketUrl);
                socket.onmessage = handleMessage;
            }
        }, 5000);
    };

    return () => socket.close();
  }, [user]);

  return (
    <>
      {/* 1. Telephony Interaction Modal */}
      {activeCall && (
        <CallInteractionModal 
          callData={activeCall} 
          onClose={() => setActiveCall(null)} 
        />
      )}

      {/* 2. Follow-up Reminder Toast */}
      {activeReminder && (
        <div className="notification-toast-overlay" style={{
            position: 'fixed',
            bottom: '24px',
            right: '24px',
            zIndex: 9999,
            animation: 'slideInRight 0.4s ease-out'
        }}>
            <div style={{
                background: '#fff',
                width: '320px',
                borderRadius: '12px',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                border: '1px solid #e2e8f0',
                padding: '16px',
                display: 'flex',
                gap: '12px',
                position: 'relative',
                overflow: 'hidden'
            }}>
                {/* Progress bar for auto-hide */}
                <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    height: '3px',
                    background: '#3b82f6',
                    width: '100%',
                    animation: 'progressShrink 10s linear forwards'
                }} />

                <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '10px',
                    background: '#eff6ff',
                    color: '#1d4ed8',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '18px',
                    flexShrink: 0
                }}>
                    <FontAwesomeIcon icon={faCalendarCheck} />
                </div>

                <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: '14px', color: '#1e293b', marginBottom: '4px' }}>
                        {activeReminder.title}
                    </div>
                    <div style={{ fontSize: '12px', color: '#64748b', lineHeight: '1.4', marginBottom: '8px' }}>
                        {activeReminder.content}
                    </div>
                    <button 
                        onClick={() => {
                            if (activeReminder.link) navigate(activeReminder.link);
                            setActiveReminder(null);
                        }}
                        style={{
                            background: '#3b82f6',
                            color: '#fff',
                            border: 'none',
                            padding: '6px 12px',
                            borderRadius: '6px',
                            fontSize: '11px',
                            fontWeight: 700,
                            cursor: 'pointer'
                        }}
                    >
                        View Lead
                    </button>
                </div>

                <button 
                    onClick={() => setActiveReminder(null)}
                    style={{
                        position: 'absolute',
                        top: '12px',
                        right: '12px',
                        background: 'transparent',
                        border: 'none',
                        color: '#94a3b8',
                        cursor: 'pointer',
                        fontSize: '14px'
                    }}
                >
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
            
            <style>{`
                @keyframes slideInRight {
                    from { transform: translateX(100%); opacity: 0; }
                    to { transform: translateX(0); opacity: 1; }
                }
                @keyframes progressShrink {
                    from { width: 100%; }
                    to { width: 0%; }
                }
            `}</style>
        </div>
      )}
    </>
  );
}
